import { r as read } from "../../../../chunks/index3.js";
import { I as Icon } from "../../../../chunks/icon.js";
const GET = async () => {
  return read(Icon);
};
export {
  GET
};
